import { createSlice } from "@reduxjs/toolkit";
import { SearchPropType } from "./types";

const initialStateValue: SearchPropType = {
  establishment: {
    data: [],
    total: 0,
    per_page: 0,
    current_page: 0,
    last_page: 0,
    first_page: 0,
    first_page_url: "",
    last_page_url: "",
    next_page_url: "",
    previous_page_url: "",
  },
  product: {
    data: [],
    total: 0,
    per_page: 0,
    current_page: 0,
    last_page: 0,
    first_page: 0,
    first_page_url: "",
    last_page_url: "",
    next_page_url: "",
    previous_page_url: "",
  },
  searchLoading: true,
  searchItemLoading: true,
};

export const searchSlice = createSlice({
  name: "search",
  initialState: { value: initialStateValue },
  reducers: {
    setSearch: (state, action) => {
      state.value = { ...state.value, ...action.payload };
    },
    toggleSearchItemFavorite: (state, action) => {
      const item = state.value.product.data.find(
        (row) => String(row.id) === String(action.payload)
      );
      if (item) {
        item.isFavourite = !item.isFavourite;
      }
    },
    toggleSearchEstablishmentFavorite: (state, action) => {
      const est = state.value.establishment.data.find(
        (row) => String(row.id) === String(action.payload)
      );
      if (est) {
        est.isFavourite = !est.isFavourite;
      }
    },
  },
});

export const {
  setSearch,
  toggleSearchItemFavorite,
  toggleSearchEstablishmentFavorite,
} = searchSlice.actions;
export default searchSlice.reducer;
